import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'unh-banners-promo',
  templateUrl: './banners-promo.component.html',
  styleUrls: ['./banners-promo.component.scss']
})
export class BannersPromoComponent implements OnInit {
  @Input() promo;
  @Input() banner;

  constructor() { }

  ngOnInit(): void {
  }
}
